import { PopoverController } from '@ionic/angular';
import { Router } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-archive-video-detail',
  templateUrl: './archive-video-detail.page.html',
  styleUrls: ['./archive-video-detail.page.scss'],
})
export class ArchiveVideoDetailPage implements OnInit {
  @Input() video: any;
  moment = moment;
  s3_bucket: string = environment.s3_bucket_url;
  constructor(
    private router: Router,
    private popover: PopoverController
  ) { }

  ngOnInit() {
  }

  playVideo(id){
    this.popover.dismiss();
    this.router.navigate(['/video-detail/'+btoa(id) ]);
  }

}
